


// FAQ Selection Function
function selectFAQ(index) {
  // Remove active class from all question items
  document.querySelectorAll('.faq-question-item').forEach(item => {
      item.classList.remove('active');
  });
  
  // Remove active class from all icons and arrows
  document.querySelectorAll('.faq-question-icon').forEach(icon => {
      icon.classList.remove('active');
  });
  
  document.querySelectorAll('.faq-arrow').forEach(arrow => {
      arrow.classList.remove('active');
  });
  
  document.querySelectorAll('.faq-question-text').forEach(text => {
      text.classList.remove('active');
  });
  
  // Add active class to selected question item
  const selectedItem = document.querySelector(`.faq-question-item:nth-child(${index + 1})`);
  if (selectedItem) {
      selectedItem.classList.add('active');
      selectedItem.querySelector('.faq-question-icon').classList.add('active');
      selectedItem.querySelector('.faq-arrow').classList.add('active');
      selectedItem.querySelector('.faq-question-text').classList.add('active');
  }
  
  // Update the answer content
  const faqData = window.faqsData ? window.faqsData[index] : null;
  if (faqData) {
      document.querySelector('.faq-answer-title').textContent = faqData.name;
      document.querySelector('.faq-answer-text').textContent = faqData.desc;
  }
}



// when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  // on .nav-menu-button click
  const io = new IntersectionObserver((entries) =>
       entries.forEach((entry) => {
           // set image source only when it is in the viewport
           if (entry.isIntersecting) {
               const image = entry.target;
               // setting image source from the dataset
               image.src = image.dataset.src;
               image.style = null;

               // when image is loaded, we do not need to observe it any more
               io.unobserve(image);
           }
       })
   );
   
   setTimeout(() => {
     document.querySelectorAll('.lazyloaded').forEach(
       (target) => target.classList.add('load')
     );
     document.querySelectorAll(".lazyobs").forEach((element) => io.observe(element));
   }, 2500);
   setTimeout(() => {
     document.querySelectorAll(".banimgdel").forEach((element) => element.classList.add('shown'));
   }, 2600);

   const lazyImages = document.querySelectorAll('img.lazyn');

   const imageObserver = new IntersectionObserver((entries, observer) => {
       entries.forEach(entry => {
           if (entry.isIntersecting) {
               const img = entry.target;
               img.src = img.dataset.src; // Set the src attribute to the data-src value
               img.style = null;
               // Load the sources
               const sources = img.parentElement.querySelectorAll('source');
               sources.forEach(source => {
                   source.srcset = source.dataset.srcset; // Set the srcset attribute to the data-srcset value
               });

               img.classList.remove('lazyn'); // Remove the lazy class
               observer.unobserve(img); // Stop observing the image
           }
       });
   });

   lazyImages.forEach(image => {
       setTimeout(() => {
         imageObserver.observe(image); // Start observing each lazy image
       }, 2000);
   });



   
   document.querySelectorAll('.nohash').forEach(function(target){
       target.addEventListener('click', function(e){
           e.preventDefault();
           var hyperLink = this.getAttribute('href');
           var redirectTo = hyperLink.replace('#', '');
           var targetElement = document.getElementById(redirectTo);
           if (targetElement) {
               targetElement.scrollIntoView({behavior: "smooth"});
           }
       })
   });
   document.querySelectorAll('.prevent').forEach(function(target){
       target.addEventListener('click', function(e){
           e.preventDefault();
           var hyperLink = this.getAttribute('href');
           var redirectTo = hyperLink.replace('#', '');
       })
   });

   let navToggle = document.querySelector('.nav-toggle');
   let bars = document.querySelectorAll('.navbar-collapse');
   let headm = document.querySelectorAll('.headn');
   let navbartoggler = document.querySelectorAll('.navbar-toggler');

   function toggleHamburger(e) {
     bars.forEach(bar => {
         bar.classList.toggle('show');
       }
     )
     headm.forEach(headm => {
         headm.classList.toggle('hedtoggle');
       }
     )
     navToggle.classList.toggle('toggle');
   }

  //  navToggle.addEventListener('click', toggleHamburger);

   
   window.addEventListener( 'resize', () => {
     if ( window.innerWidth < 700 ) {
       document.querySelectorAll('.nvlink').forEach(function(target){
           target.addEventListener('click', function(e){
             // headm.classList.remove('hedtoggle');
             bars.forEach(bar => {
                 bar.classList.toggle('show');
               }
             )
             headm.forEach(headm => {
                 headm.classList.toggle('hedtoggle');
               }
             )
             navbartoggler.forEach(navbartoggler => {
                 navbartoggler.classList.toggle('toggle');
               }
             )
           })
       });
     } else {
       bars.forEach( bar => { bar.classList.remove('show'); } )
       headm.forEach( headm => { headm.classList.remove('hedtoggle'); } )
       navbartoggler.forEach( navbartoggler => { navbartoggler.classList.remove('toggle'); } )
     }
    
   });
   if ( window.innerWidth < 700 ) {
       document.querySelectorAll('.nvlink').forEach(function(target){
           target.addEventListener('click', function(e){
             // headm.classList.remove('hedtoggle');
             bars.forEach(bar => {
                 bar.classList.toggle('show');
               }
             )
             headm.forEach(headm => {
                 headm.classList.toggle('hedtoggle');
               }
             )
             navbartoggler.forEach(navbartoggler => {
                 navbartoggler.classList.toggle('toggle');
               }
             )
           })
       });
     } else {
       bars.forEach( bar => { bar.classList.remove('show'); } )
       headm.forEach( headm => { headm.classList.remove('hedtoggle'); } )
       navbartoggler.forEach( navbartoggler => { navbartoggler.classList.remove('toggle'); } )
   }
   

   // let servToggle = document.querySelector('.servitem')
   //  function toggleServitem(e) {
   //   servToggle.classList.remove('active')
   // }

   // servToggle.addEventListener('click', toggleServitem);


   const mousedrag = document.querySelectorAll('.scrolcusto');
   mousedrag.forEach(slider => {
       let mouseDown = false;
       let startX, scrollLeft;

       let startDragging = function (e) {
         mouseDown = true;
         startX = e.pageX - slider.offsetLeft;
         scrollLeft = slider.scrollLeft;
       };
       let stopDragging = function (e) {
         mouseDown = false;
       };

       slider.addEventListener('mousemove', (e) => {
         e.preventDefault();
         if(!mouseDown) { return; }
         const x = e.pageX - slider.offsetLeft;
         const scroll = x - startX;
         slider.scrollLeft = scrollLeft - scroll;
       });
       // Add the event listeners
       slider.addEventListener('mousedown', startDragging, false);
       slider.addEventListener('mouseup', stopDragging, false);
       slider.addEventListener('mouseleave', stopDragging, false);
   });

   // var classtarget = document.querySelectorAll('.revitem');
   // function moveIt() {
   //   var innerDiv = document.getElementsByClassName("rem")[0];
   //   var classn = document.getElementsByClassName("revshow")[0];
   //   var outerDiv = innerDiv.parentElement;

   //   if (outerDiv.nextElementSibling != null) {
   //     outerDiv.nextElementSibling.classList.add('revshow'); 
   //     outerDiv.classList.remove('revshow');
   //     outerDiv.nextElementSibling.appendChild(outerDiv.removeChild(innerDiv));
   //   } else {
   //     outerDiv.parentElement.firstElementChild.appendChild(
   //       outerDiv.removeChild(innerDiv)
   //     );
   //     outerDiv.classList.remove('revshow');
   //     outerDiv.parentElement.firstElementChild.classList.add('revshow');
       
   //   }
   // }
   // setInterval(function() {
   //   moveIt();
   // }, 2 * 1000);

   const accordions = document.querySelectorAll(".accordion");
   const openAccordion = (accordion) => {
     const content = accordion.querySelector(".accordion__content");
     accordion.classList.add("accordion__active");
     content.style.maxHeight = content.scrollHeight + "px";
   };

   const closeAccordion = (accordion) => {
     const content = accordion.querySelector(".accordion__content");
     accordion.classList.remove("accordion__active");
     content.style.maxHeight = null;
   };

   accordions.forEach((accordion) => {
     const intro = accordion.querySelector(".accordion__intro");
     const content = accordion.querySelector(".accordion__content");

     intro.onclick = () => {
       if (content.style.maxHeight) {
         closeAccordion(accordion);
       } else {
         accordions.forEach((accordion) => closeAccordion(accordion));
         openAccordion(accordion);
       }
     };
   });

   // const accordionservli = document.querySelectorAll(".servitem");
   // accordionservli.forEach((accordion,i) => { 
   //   const intro2 = accordion.querySelector(".servtoggle");
   //   intro2.addEventListener("click", () => { 
   //       accordion.classList.toggle("active"); 
   //       // let description = accordion.querySelector(".descrtp"); 
   //       // if(accordion.classList.contains("active")){ 
   //       // }else{ 
   //       // } 
   //       removeExistClass(i);  
   //   });
   // });
  
   function removeExistClass(i){ 
       accordionwhyli.forEach((accodn,ii)=>{ 
           if(i != ii){ 
               accodn.classList.remove("activen"); 
           } 
       }) 
   }

    var video = document.getElementById('mainVideo');
    var playBtn = document.getElementById('mainPlayBtn');
    var videoContainer = video ? video.closest('.video-item') : null;

    // iOS detection - improved to catch more iOS devices
    function isIOS() {
        return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream ||
               (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1); // iPad Pro detection
    }

    // Show controls when playing, hide when paused
    function updateVideoUI() {
        if (!video || !playBtn) return;
        if (video.paused) {
            playBtn.style.display = 'block';
            // On iOS, controls must be visible for user interaction
            if (isIOS()) {
                video.setAttribute('controls', 'controls');
            } else {
                video.removeAttribute('controls');
            }
        } else {
            playBtn.style.display = 'none';
            video.setAttribute('controls', 'controls');
        }
    }

    // Buffering logic based on internet speed
    function getNetworkSpeed(callback) {
        var image = new Image();
        var startTime, endTime;
        var imageSize = 50000; // 50KB (approx)
        var cacheBuster = "?nn=" + Math.random();
        image.onload = function () {
            endTime = (new Date()).getTime();
            var duration = (endTime - startTime) / 1000;
            var bitsLoaded = imageSize * 8;
            var speedBps = bitsLoaded / duration;
            var speedKbps = speedBps / 1024;
            var speedMbps = speedKbps / 1024;
            callback(speedMbps);
        };
        image.onerror = function () {
            callback(1);
        };
        startTime = (new Date()).getTime();
        image.src = "https://www.google.com/images/phd/px.gif" + cacheBuster;
    }

    // Set video preload and quality based on speed
    function setVideoBufferingBySpeed() {
        if (!video) return;
        getNetworkSpeed(function(speedMbps) {
            if (speedMbps < 1) {
                video.preload = "metadata";
            } else if (speedMbps < 3) {
                video.preload = "auto";
            } else {
                video.preload = "auto";
            }
        });
    }

    // Play video on playbtn click, but ensure enough is buffered
    if (playBtn && video) {
        playBtn.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            
            // For iOS, always show controls first
            if (isIOS()) {
                video.setAttribute('controls', 'controls');
                video.setAttribute('playsinline', '');
                video.setAttribute('webkit-playsinline', '');
                
                // On iOS, try to play immediately without buffering checks
                video.play().then(function() {
                    updateVideoUI();
                }).catch(function(error) {
                    // Fallback: show controls and let user interact
                    video.setAttribute('controls', 'controls');
                    playBtn.style.display = 'block';
                });
                return;
            }
            
            // For non-iOS devices, use buffering logic
            var minBuffer = 2; // Reduced for better UX
            function tryPlayWhenBuffered() {
                var buffered = video.buffered;
                if (buffered.length > 0) {
                    var bufferedEnd = buffered.end(0);
                    if (bufferedEnd >= minBuffer || video.readyState >= 3) {
                        video.play().then(function() {
                            updateVideoUI();
                        }).catch(function(error) {
                            video.setAttribute('controls', 'controls');
                            playBtn.style.display = 'block';
                        });
                    } else {
                        setTimeout(tryPlayWhenBuffered, 200);
                    }
                } else {
                    // If no buffer data, try to play anyway
                    video.play().then(function() {
                        updateVideoUI();
                    }).catch(function(error) {
                        setTimeout(tryPlayWhenBuffered, 200);
                    });
                }
            }
            
            tryPlayWhenBuffered();
        });
    }

    // Update UI on play/pause events
    if (video) {
        video.addEventListener('play', updateVideoUI);
        video.addEventListener('pause', updateVideoUI);
        video.addEventListener('ended', updateVideoUI);
    }

    // Pause video if scrolled out of view (not on iOS, as background pausing is handled by OS)
    function isElementInViewport(el) {
        if (!el) return false;
        var rect = el.getBoundingClientRect();
        return (
            rect.top < window.innerHeight &&
            rect.bottom > 0
        );
    }

    function handleScrollPause() {
        if (isIOS() || !video || !videoContainer) return;
        if (!isElementInViewport(videoContainer)) {
            if (!video.paused) {
                video.pause();
            }
        }
    }

    window.addEventListener('scroll', handleScrollPause, { passive: true });

    // Initial setup
    if (video) {
        // Set iOS attributes early
        if (isIOS()) {
            video.setAttribute('playsinline', '');
            video.setAttribute('webkit-playsinline', '');
            video.setAttribute('muted', ''); // Often needed for autoplay on iOS
        }
        
        setVideoBufferingBySpeed();
        updateVideoUI();
        
        // Add a fallback click handler directly on the video for iOS
        if (isIOS()) {
            video.addEventListener('click', function() {
                if (video.paused) {
                    video.play().then(function() {
                        updateVideoUI();
                    }).catch(function(error) {
                    });
                }
            });
        }
    }
   
 
   // define an observer instance
   var observer = new IntersectionObserver(onScrolIntersection, {
     root: null, // default is the viewport
     threshold: 0.4, // percentage of taregt's visible area."
   });
   
   // callback is called on intersection change
   function onScrolIntersection(entries, opts) {
     entries.forEach((entry) => {
       // console.log(entry);
       if(entry.isIntersecting) {
         entry.target.classList.add('anim');
       } else {
         entry.target.classList.remove('anim');
       }
     });
   }
   // Use the bserver to observe an element
   // observer.observe(document.querySelector(".setlist"));


   let scrollpos = window.scrollY
   const header = document.querySelector("header");
   const header_height = header.clientHeight - 10;
  
   
   
   window.addEventListener('scroll', function(e) { 
    
     scrollpos = window.scrollY;

     // console.log(slindx1_height, slindx2_height);

     if (scrollpos > header_height) {
       header.classList.add("scrolin");
       setTimeout(() => {
         header.classList.add("htop");
       }, 50);
     }
     else {
       header.classList.remove("scrolin");
       header.classList.remove("scrolledUp");
       setTimeout(() => {
         header.classList.remove("htop");
       }, 50);
     }
   
     if (scrollpos >= header_height) { header.classList.add("active"); }
     else { header.classList.remove("active"); }

  
   })

   
   
   document.querySelectorAll(".cformpop").forEach(function (e) {
     e.addEventListener("click", function (e) {
       e.preventDefault(),
         document.body.classList.add("noscrol"),
         document.getElementById("contact").classList.add("ntop"),
         document.querySelector(".sec2-wrap").classList.add("moacvt"),
         setTimeout(() => {
           document.getElementById("contact").classList.add("position-fixed")
         }
           , 50)
     })
   });
   document.querySelectorAll(".cformclose").forEach(function(e) {
       e.addEventListener("click", function(e) {
           e.preventDefault(),
           document.getElementById("contact").classList.remove("position-fixed"),
           document.querySelector(".sec2-wrap").classList.remove("moacvt"),
           document.body.classList.remove("noscrol"),
           setTimeout( () => {
               document.getElementById("contact").classList.remove("ntop")
           }
           , 500)
       })
   });
   

 
   
   // initialize();

   // document.querySelectorAll('.inputfrm').forEach(function(target){
   //     const isEmpty = str => !str.trim().length;
   //     target.addEventListener("input", function() {
   //       if( isEmpty(this.value) ) {
   //         target.parentElement.classList.add('error');
   //         target.parentElement.classList.remove('notempty');
   //       } else {
   //         target.parentElement.classList.remove('error');
   //         target.parentElement.classList.add('notempty');
   //       }
   //     });
   // });


   document.querySelectorAll('.title').forEach(function(target){
       target.addEventListener('click', function(e){
         target.parentElement.parentElement.classList.toggle('show')
       })
   });

   document.querySelectorAll('.cformnall').forEach(function(target){
       var errorElementAll = document.getElementById('errorform');

       target.addEventListener('submit', function(event){
           // Prevent form submission
       event.preventDefault();
       // Clear previous error messages
       clearErrors();
       // Validate the form
       let isValid = true;
       // Get all input elements in the form
       const inputs = this.querySelectorAll('.required');
       inputs.forEach(input => {
           const value = input.value.trim();
           const errorElement = document.getElementById(input.id + 'Error');
           // Check if the field is empty
           if (value === '') {
               showError(errorElement, 'This field is required.');
               input.classList.add("berror");
               input.parentNode.classList.add('erron');

               isValid = false;
               return; // Skip to the next input
           }
           // Additional validation based on input type
           if (input.type === 'email') {
               const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
               if (!emailPattern.test(value)) {
                   showError(errorElement, 'Please enter a valid email address.');
                   isValid = false;
               }
           }
           if (input.type === 'tel') {
               // const phonePattern = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
             // var phonePattern = /^(\+?\(61\)|\(\+?61\)|\+?61|\(0[1-9]\)|0[1-9])?( ?-?[0-9]){7,9}$/;
             var phonePattern = /^(\+?\(61\)|\(\+?61\)|\+?61|\(0[1-9]\)|0[1-9])?( ?-?[0-9]){7,9}$/;
             // const phonePatternempty = /^0\d{9}$/;
               if (!phonePattern.test(value)) {
                   showError(errorElement, 'Invalid phone number. No spaces');
                   isValid = false;
               }
           }
       });

       // If the form is valid, you can submit it or perform other actions
       if (isValid) {
         const formData = new FormData(this);
         // document.querySelector(".inputnamval").style.opacity = 0;
         // document.querySelector(".inputnamval").disabled = true;
         // document.querySelector(".spinner-border").style.display = 'block';
         // AJAX request
         fetch('src/form.php', {
             method: 'POST',
             body: formData
         })
         .then(response => {
             if (!response.ok) {
                 throw new Error('Network response was not ok');
             }
             return response.json();
         })
         .then(data => {
             // console.log(data);
             if(data.redirect) {
               setTimeout(() => {
                 window.location.href = data.location;
               }, 1000);
             }
             else {
               // alert(data.message);
               showErrorAll(errorElementAll, data.message);
             }

         })
         .catch(error => {
             // document.querySelector(".inputnamval").style.opacity = 1;
             // setTimeout(() => {
             //   document.querySelector(".inputnamval").disabled = false;s
             // }, 500);
             // document.querySelector(".spinner-border").style.display = 'none';
             // alert('There was a problem with the fetch operation:', error);
             showErrorAll(errorElementAll, 'There was a problem with the fetch operation:', error);
         });
       }
       })
   });

   // Auto-scroll
   (function() {
      const el = document.getElementById('serviceListScrollable');
      if (!el) return;
      let autoScrollActive = true;
      let autoScrollId;
      let isTransitioning = false;
      let resumeTimeoutId = null;
      let currentSlideIndex = 0;
      const RESUME_DELAY = 2000; // ms to delay autoplay after drag/touch
      const SLIDE_INTERVAL = 3000; // ms between slides
      const SLIDE_DURATION = 800; // ms for slide animation

      function getSlidePositions() {
          const slides = el.querySelectorAll('.item'); // Match the actual HTML class
          const positions = [];
          slides.forEach((slide, index) => {
              // Get the slide's left position relative to the scrollable container
              const slideLeft = slide.offsetLeft;
              positions.push(slideLeft);
          });
          return positions;
      }

      function getVisibleSlideWidth() {
          const slides = el.querySelectorAll('.item');
          if (slides.length === 0) return 0;
          
          // Calculate how many slides fit in the visible area
          const containerWidth = el.clientWidth;
          const slideWidth = slides[0].offsetWidth;
          const slidesPerView = Math.floor(containerWidth / slideWidth);
          
          return slideWidth * slidesPerView;
      }

      function smoothScrollTo(target, duration = 600) {
          if (isTransitioning) return;
          isTransitioning = true;
          const start = el.scrollLeft;
          const change = target - start;
          const startTime = performance.now();

          function animateScroll(currentTime) {
              const elapsed = currentTime - startTime;
              const progress = Math.min(elapsed / duration, 1);
              el.scrollLeft = start + change * easeInOutQuad(progress);
              
              // Update active slide during animation
              updateActiveSlide();
              
              if (progress < 1) {
                  requestAnimationFrame(animateScroll);
              } else {
                  isTransitioning = false;
                  // Final update when animation completes
                  updateActiveSlide();
              }
          }
          requestAnimationFrame(animateScroll);
      }

      function easeInOutQuad(t) {
          return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
      }

      function updateActiveSlide() {
          const slides = el.querySelectorAll('.item');
          if (slides.length === 0) return;
          
          const containerWidth = el.clientWidth;
          const scrollLeft = el.scrollLeft;
          const containerCenter = scrollLeft + (containerWidth / 2);
          
          // Remove active class from all slides
          slides.forEach(slide => slide.classList.remove('active-slide'));
          
          // Find the slide closest to center with improved precision
          let closestSlide = null;
          let closestDistance = Infinity;
          let newActiveIndex = 0;
          
          slides.forEach((slide, index) => {
              const slideLeft = slide.offsetLeft;
              const slideWidth = slide.offsetWidth;
              const slideCenter = slideLeft + (slideWidth / 2);
              const distance = Math.abs(containerCenter - slideCenter);
              
              if (distance < closestDistance) {
                  closestDistance = distance;
                  closestSlide = slide;
                  newActiveIndex = index;
              }
          });
          
          // Update current slide index and add active class
          if (closestSlide) {
              currentSlideIndex = newActiveIndex;
              closestSlide.classList.add('active-slide');
              
             
          }
      }

      function scrollToSlideCenter(slideIndex) {
          const slides = el.querySelectorAll('.item');
          if (slideIndex >= slides.length || slideIndex < 0) return;
          
          const slide = slides[slideIndex];
          const containerWidth = el.clientWidth;
          const slideWidth = slide.offsetWidth;
          
          // Calculate the exact center position
          const slideLeft = slide.offsetLeft;
          const slideCenter = slideLeft + (slideWidth / 2);
          const containerCenter = containerWidth / 2;
          
          // Target scroll position to center the slide
          const scrollTarget = slideCenter - containerCenter;
          
          // Ensure we don't scroll past bounds
          const maxScroll = el.scrollWidth - containerWidth;
          const finalTarget = Math.max(0, Math.min(scrollTarget, maxScroll));
          
         
          
          smoothScrollTo(finalTarget, SLIDE_DURATION);
      }

      function autoSlide() {
          if (!autoScrollActive || isTransitioning) return;
          
          const slides = el.querySelectorAll('.item');
          if (slides.length === 0) return;
          
          // Move to next slide (one at a time)
          currentSlideIndex = (currentSlideIndex + 1) % slides.length;
          
          // Scroll to center the current slide
          scrollToSlideCenter(currentSlideIndex);
          
          // Schedule next slide
          autoScrollId = setTimeout(() => {
              if (autoScrollActive) autoSlide();
          }, SLIDE_INTERVAL);
      }

      function startAutoSlide() {
          if (!autoScrollActive) return;
          autoScrollId = setTimeout(() => {
              if (autoScrollActive) autoSlide();
          }, SLIDE_INTERVAL);
      }

      function stopAutoSlide() {
          if (autoScrollId) {
              clearTimeout(autoScrollId);
              autoScrollId = null;
          }
      }

      // Debug: Check if slides are found
      setTimeout(() => {
          const slides = el.querySelectorAll('.item');
          
      }, 100);

      // Initialize active slide and center first slide
      setTimeout(() => {
          const slides = el.querySelectorAll('.item');
          if (slides.length > 0) {
              // Start with first slide centered
              currentSlideIndex = 0;
              scrollToSlideCenter(0);
              // Small delay to ensure centering completes before updating active
              setTimeout(() => {
                  updateActiveSlide();
              }, 100);
          }
      }, 200);

      // Manual centering function (for testing or manual navigation)
      function centerSlideByIndex(index) {
          const slides = el.querySelectorAll('.item');
          if (index >= 0 && index < slides.length) {
              stopAutoSlide();
              currentSlideIndex = index;
              scrollToSlideCenter(index);
              // Resume auto-slide after manual centering
              setTimeout(() => {
                  autoScrollActive = true;
                  startAutoSlide();
              }, RESUME_DELAY);
          }
      }

      // Expose function globally for testing
      window.centerSlide = centerSlideByIndex;

      // Start the auto-slide
      startAutoSlide();

      // Pause auto-slide on mouse enter, resume on leave (hover)
      el.addEventListener('mouseenter', () => { 
          autoScrollActive = false; 
          stopAutoSlide();
      });
      el.addEventListener('mouseleave', () => {
          autoScrollActive = true;
          if (!isTransitioning) startAutoSlide();
      });

      // Pause auto-slide when hovering over custom scrollbar
      const customScrollbar = document.getElementById('customScrollbar');
      if (customScrollbar) {
          customScrollbar.addEventListener('mouseenter', () => {
              autoScrollActive = false;
              stopAutoSlide();
          });
          customScrollbar.addEventListener('mouseleave', () => {
              autoScrollActive = true;
              if (!isTransitioning) startAutoSlide();
          });
      }

      // Drag to scroll
      let isDown = false;
      let startX, scrollLeftStart;
      function delayResumeAutoSlide() {
          if (resumeTimeoutId) clearTimeout(resumeTimeoutId);
          resumeTimeoutId = setTimeout(() => {
              autoScrollActive = true;
              if (!isTransitioning) startAutoSlide();
          }, RESUME_DELAY);
      }
      el.addEventListener('mousedown', (e) => {
          isDown = true;
          el.classList.add('active');
          startX = e.pageX - el.offsetLeft;
          scrollLeftStart = el.scrollLeft;
          autoScrollActive = false;
          stopAutoSlide();
          if (resumeTimeoutId) clearTimeout(resumeTimeoutId);
      });
      el.addEventListener('mouseleave', () => {
          if (isDown) {
              isDown = false;
              el.classList.remove('active');
              delayResumeAutoSlide();
          }
      });
      el.addEventListener('mouseup', () => {
          if (isDown) {
              isDown = false;
              el.classList.remove('active');
              delayResumeAutoSlide();
          }
      });
      el.addEventListener('mousemove', (e) => {
          if (!isDown) return;
          e.preventDefault();
          const x = e.pageX - el.offsetLeft;
          const walk = (x - startX) * 1.5; // scroll-fast
          el.scrollLeft = scrollLeftStart - walk;
      });

      // Touch support
      let touchStartX = 0, touchScrollLeft = 0;
      el.addEventListener('touchstart', (e) => {
          autoScrollActive = false;
          stopAutoSlide();
          isDown = true;
          touchStartX = e.touches[0].pageX;
          touchScrollLeft = el.scrollLeft;
          if (resumeTimeoutId) clearTimeout(resumeTimeoutId);
      });
      el.addEventListener('touchend', () => {
          if (isDown) {
              isDown = false;
              delayResumeAutoSlide();
          }
      });
      el.addEventListener('touchcancel', () => {
          if (isDown) {
              isDown = false;
              delayResumeAutoSlide();
          }
      });
      el.addEventListener('touchmove', (e) => {
          if (!isDown) return;
          const x = e.touches[0].pageX;
          const walk = (x - touchStartX) * 1.5;
          el.scrollLeft = touchScrollLeft - walk;
      });

      const scrollable = document.getElementById('serviceListScrollable');
      const scrollbar = document.getElementById('customScrollbar');
      const thumb = document.getElementById('scrollbarThumb');

      function updateThumb() {
          const scrollWidth = scrollable.scrollWidth;
          const clientWidth = scrollable.clientWidth;
          const scrollLeft = scrollable.scrollLeft;
          const scrollbarWidth = scrollbar.clientWidth;

          // Thumb width proportional to visible area
          const thumbWidth = Math.max((clientWidth / scrollWidth) * scrollbarWidth, 30);
          thumb.style.width = thumbWidth + 'px';

          // Thumb position proportional to scroll
          const maxScrollLeft = scrollWidth - clientWidth;
          const maxThumbLeft = scrollbarWidth - thumbWidth;
          const thumbLeft = maxScrollLeft > 0 ? (scrollLeft / maxScrollLeft) * maxThumbLeft : 0;
          thumb.style.left = thumbLeft + 'px';
      }

      // Sync thumb on scroll and update active slide
      scrollable.addEventListener('scroll', () => {
          updateThumb();
          if (!isTransitioning) {
              updateActiveSlide();
          }
      });
      window.addEventListener('resize', () => {
          updateThumb();
          updateActiveSlide();
      });

      // Drag to scroll
      let isDragging = false;
      let dragStartX = 0;
      let dragStartScrollLeft = 0;

      thumb.addEventListener('mousedown', function(e) {
          isDragging = true;
          dragStartX = e.clientX;
          dragStartScrollLeft = scrollable.scrollLeft;
          document.body.style.userSelect = 'none';
      });

      document.addEventListener('mousemove', function(e) {
          if (!isDragging) return;
          const scrollbarWidth = scrollbar.clientWidth;
          const thumbWidth = thumb.clientWidth;
          const maxScrollLeft = scrollable.scrollWidth - scrollable.clientWidth;
          const maxThumbLeft = scrollbarWidth - thumbWidth;
          const dx = e.clientX - dragStartX;
          const scrollDelta = (dx / maxThumbLeft) * maxScrollLeft;
          scrollable.scrollLeft = dragStartScrollLeft + scrollDelta;
      });

      document.addEventListener('mouseup', function() {
          isDragging = false;
          document.body.style.userSelect = '';
      });

      // Click on scrollbar to jump
      scrollbar.addEventListener('click', function(e) {
          if (e.target === thumb) return;
          const rect = scrollbar.getBoundingClientRect();
          const clickX = e.clientX - rect.left;
          const thumbWidth = thumb.clientWidth;
          const scrollbarWidth = scrollbar.clientWidth;
          const maxScrollLeft = scrollable.scrollWidth - scrollable.clientWidth;
          const maxThumbLeft = scrollbarWidth - thumbWidth;
          const thumbCenter = thumbWidth / 2;
          let newThumbLeft = clickX - thumbCenter;
          newThumbLeft = Math.max(0, Math.min(newThumbLeft, maxThumbLeft));
          const newScrollLeft = (newThumbLeft / maxThumbLeft) * maxScrollLeft;
          scrollable.scrollLeft = newScrollLeft;
      });

      // Initial thumb update
      updateThumb();
  })();

  

   AOS.init();
   let scrollRef = 0;
   window.addEventListener('resize', () => {
     // increase value up to 10, then refresh AOS
     scrollRef <= 10 ? scrollRef++ : AOS.refresh();
   });

  

});






function showError(errorElement, message) {
 errorElement.textContent = message;
}
function showErrorAll(errorElement, message) {
 errorElement.innerHTML  = '<div class="erronall"><span>'+message+'</span></div>';
 const yOffset = -300; 
 
 const errorform = document.getElementById('errorform');
 const y = errorform.getBoundingClientRect().top + window.scrollY + yOffset;
 // errorform.scrollIntoView({behavior: "smooth"});
 window.scrollTo({top: y, behavior: 'smooth'});

}
function clearErrors() {
 const errorElements = document.querySelectorAll('.frmerror');
 const errorElements2 = document.querySelectorAll('.berror');
 const errorElements3 = document.querySelectorAll('.erronall');
 errorElements.forEach(element => {
     element.textContent = '';
 });
 errorElements2.forEach(element => {
     element.classList.remove('berror');
 });
 errorElements3.forEach(element => {
     element.remove();
 });
}


// SwiperJS Configuration for Banner Promo
var bannerSwiper = new Swiper('#bannpromo', {
    // Basic Settings
    slidesPerView: 1,
    spaceBetween: 0,
    loop: false,
    centeredSlides: true,
    
    // Auto-play
    autoplay: {
        delay: 3000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
    },
    
    // Smooth transitions
    speed: 600,
    
    // Pagination dots
    pagination: {
        el: '.bannpromo-wrap .swiper-pagination',
        clickable: true,
        dynamicBullets: false,
    },
    
    
    
});


// SwiperJS Configuration for Services
var serviceSwiper = new Swiper('#serviceSwiper', {
    // Basic Settings
    slidesPerView: 1.2,
    spaceBetween: 0,
    centeredSlides: true,
    loop: true,
    
    // Auto-play
    autoplay: {
        delay: 3000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
    },
    
    // Smooth transitions
    speed: 800,
    
    // Built-in scrollbar
    scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
        dragSize: 'auto',
    },
    
    // Responsive breakpoints
    breakpoints: {
        540: {
            slidesPerView: 2,
            spaceBetween: 0,
        },
        700: {
            slidesPerView: 2,
            spaceBetween: 10,
        },
        812: {
            slidesPerView: 3,
            spaceBetween: 0,
        },
        991: {
            slidesPerView: 3,
            spaceBetween: 0,
        },
        1200: {
            slidesPerView: 4,
            spaceBetween: 0,
        },
        1400: {
            slidesPerView: 4,
            spaceBetween: 0,
        },
        1600: {
            slidesPerView: 4,
            spaceBetween: 0,
        },
    },
    
    // Events for active slide detection
    on: {
        init: function () {
            updateActiveSlide();
        },
        slideChange: function () {
            updateActiveSlide();
        }
    }
});

// Active slide detection for SwiperJS
function updateActiveSlide() {
    const swiperElement = document.getElementById('serviceSwiper');
    if (!swiperElement || !serviceSwiper) return;
    
    const slides = swiperElement.querySelectorAll('.swiper-slide');
    const activeIndex = serviceSwiper.activeIndex;
    const slidesPerView = serviceSwiper.params.slidesPerView;
    
    // Remove all active classes
    slides.forEach(slide => {
        const item = slide.querySelector('.item');
        if (item) item.classList.remove('active-slide');
    });
    
    // Calculate center slides based on slidesPerView
    let centerSlides = [];
    if (slidesPerView === 1) {
        centerSlides = [activeIndex];
    } else if (slidesPerView === 2) {
        centerSlides = [activeIndex, activeIndex + 1];
    } else if (slidesPerView === 3) {
        centerSlides = [activeIndex + 1];
    } else if (slidesPerView === 4) {
        centerSlides = [activeIndex + 1, activeIndex + 2];
    }
    
    // Apply active class to center slides
    centerSlides.forEach(index => {
        if (index >= 0 && index < slides.length) {
            const slide = slides[index];
            const item = slide.querySelector('.item');
            if (item) item.classList.add('active-slide');
        }
    });
    
    
}

